import { mapState } from 'vuex';
import ReportTable from '@/components/reports/table/ReportTable.vue'
import LogList from '@/components/log/list/LogList.vue'
import MaterialLookup from '@/components/material/lookup/MaterialLookup.vue'
import SummaryPlacedSimple from '@/components/reports/summaryplacedsimple/SummaryPlacedSimple.vue'
import AxaptBillsList from '@/components/axaptbills/list/AxaptBillsList.vue'
import ClientBillAttach from '@/components/client/bills/attach/ClientBillAttach.vue'

export default {
  name: 'ClientReport',
  data () {
    return {
      datePeriodCode: null,
      clientApiId: null,
      reportCode: null,
      reportData: null,
      reportCosts: null,
      reportBilledCosts: null,
      reportTableConfig: null,
      clientReport: null,
      client: null,
      log: null,
      loading: true,
      errors: null,
      mounted: false,
      discount: null,
      reportTaxrate: null
    }
  },
  components: {
    ReportTable,
    LogList,
    MaterialLookup,
    SummaryPlacedSimple,
    AxaptBillsList,
    ClientBillAttach
  },
  computed: {
    ...mapState(['config']),
    reportStatusClass () {
      if (this.clientReport) {
        return this.ReportHelper.getReportStatusClass(this.clientReport);
      }
      return '';
    },
    reportConfig () {
      if (this.clientReport && this.clientReport.report_config) {
        return this.clientReport.report_config;
      }
      if (this.config);
      return this.$store.getters.getDataFromConfigWithFilter('report_configs', 'code', this.reportCode);
    },
    isEditable () {
      if (!this.clientReport || !this.clientReport.canEdit) {
        return false;
      }
      if (this.ApiRequest.userHasPermission('edit-reports', (this.client ? this.client.api_id : null), 'canFillReports')) {
        if (['EMPTY', 'REJECTED'].includes(this.clientReport.status) && !this.client.isBlocked && !this.client.isAxBlocked) {
          return true;
        } else if (this.ApiRequest.userHasPermission('edit-reports')) {
          return true;
        }
        return false;
      }
      return false;
    },
    editReports () {
      return this.ApiRequest.userHasPermission('edit-reports');
    },
    viewAxbills () {
      if (this.ApiRequest.userHasPermission('view-axbills')) {
        return true;
      }
      return false;
    },
    requestPath () {
      return 'report/client/' + this.clientApiId + '/' + this.reportCode + '/' + this.datePeriodCode;
    },
    viewDiscountInfo () {
      return this.ApiRequest.userHasPermission('edit-reports');
    },
    viewReportLog () {
      return this.clientReport && this.ApiRequest.userHasPermission('view-reports');
    },
    viewSummary () {
      return this.viewReportLog;
    },
    viewBilledAmount () {
      return this.ApiRequest.userHasPermission('view-reports');
    }
  },
  methods: {
    getReportData () {
      const self = this;
      this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.reportTaxrate = (response.data.client.taxrate ? parseFloat(response.data.client.taxrate) : null);
          self.ReportHelper.setParams(self.$options.filters, self);
          const showDiscount = self.viewDiscountInfo || (response.data.report.table[0] && parseFloat(response.data.report.table[0].discount) !== 0);
          if (showDiscount) {
            self.discount = ((response.data.report.table[0] && response.data.report.table[0].discount) ? parseFloat(response.data.report.table[0].discount) : null);
          }
          self.reportData = self.ReportHelper.createReportData(
            [response.data.report.table], false, response.data.report.config, 2, showDiscount,
            self.ReportHelper.defaultDisplayCols, null, self.viewBilledAmount
          )[0];
          self.reportCosts = response.data.report.costs;
          self.reportBilledCosts = response.data.report.billedCosts;
          self.reportTableConfig = response.data.report.config;
          self.client = response.data.client;
          self.clientReport = self.getClientReportData(response.data.clientReport);
        } else {
          self.errors = response.messageCodes;
          self.reportData = null;
        }
        if (self.$refs.reportTable) {
          self.$refs.reportTable.setReport(self.reportData);
        }
        self.loading = false;
      });
    },
    updateReport (postData) {
      const self = this;
      const path = 'report/client/' + this.clientApiId + '/' + this.reportCode + '/' + this.datePeriodCode;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { reportData: postData.data, nextStatus: postData.nextStatus, clientReport: postData.clientReport }, function (response) {
        if (response.data) {
          self.loadPageReportDataByResponse(response);
        } else {
          if (response.messageCodes.includes('reports.status.access-denied')) {
            self.getReportData();
          }
          self.ApiRequest.displayErrorDialog(response, self);
        }
        self.$refs.reportTable.setLoading(false);
      });
    },
    generateBill (recreate = false) {
      const self = this;
      self.$refs.reportTable.setLoading(true);
      const path = 'report/client/' + this.clientApiId + '/' + this.reportCode + '/' + this.datePeriodCode + '/create-bill';
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, { recreate: recreate }, function (response) {
        if (response.data) {
          self.loadPageReportDataByResponse(response);
        } else {
          if (response.messageCodes.includes('reports.status.access-denied')) {
            self.getReportData();
          }
          self.ApiRequest.displayErrorDialog(response, self);
        }
        self.$refs.reportTable.setLoading(false);
      });
    },
    getClientReportData (clientReport) {
      clientReport.status = this.$store.getters.getParamFromConfig('client_report_statuses', clientReport.status_id, 'code');
      clientReport.reportMessage = this.getReportMessage(clientReport.status);
      if (clientReport && clientReport.responsible_user && clientReport.responsible_user.clients.length > 0) {
        clientReport.responsible_user.client = clientReport.responsible_user.clients[0];
      }
      clientReport.filled_by_id = clientReport.filled_by ? clientReport.filled_by.api_id : null;
      clientReport.responsible_user_id = clientReport.responsible_user ? clientReport.responsible_user.api_id : null;
      if (clientReport.filled_by_id && !this.client.users.find(el => el.api_id === clientReport.filled_by_id)) {
        this.client.users.push(this.BasicHelper.cloneObject(clientReport.filled_by));
      }
      if (clientReport.responsible_user_id && !this.client.users.find(el => el.api_id === clientReport.responsible_user_id)) {
        this.client.users.push(this.BasicHelper.cloneObject(clientReport.responsible_user));
      }
      return clientReport;
    },
    getReportMessage (status) {
      const res = { class: 'text-success', label: 'report.status-message.' + status };
      if (this.client && (this.client.isBlocked || this.client.isAxBlocked)) {
        res.label = 'report.status-message.blocked-client';
        res.class = 'error';
      }
      if (['DELETED', 'REJECTED', 'FIXED'].includes(status)) {
        res.class = 'error';
      }
      return res;
    },
    downloadBill (billId) {
      this.clientReport.bills.find(el => el.id === billId).loading = true;
      this.$forceUpdate();
      const self = this;
      this.ApiRequest.request('client-bill/' + billId, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.clientReport.bills.find(el => el.id === billId).loading = false;
        self.$forceUpdate();
      });
    },
    loadPageReportDataByResponse (response) {
      const showDiscount = this.viewDiscountInfo || (response.data.report.table[0] && parseFloat(response.data.report.table[0].discount) > 0);
      this.reportData = this.ReportHelper.createReportData(
        [response.data.report.table], false, response.data.report.config, 2, showDiscount,
        this.ReportHelper.defaultDisplayCols, null, this.viewBilledAmount
      )[0];
      this.reportCosts = response.data.report.costs;
      this.reportBilledCosts = response.data.report.billedCosts;
      if (response.data.bills) {
        this.clientReport.bills = response.data.bills;
      }
      this.clientReport.status_id = response.data.clientReport.status_id;
      this.clientReport.status = this.$store.getters.getParamFromConfig('client_report_statuses', response.data.clientReport.status_id, 'code');
      if (this.$refs.logList) {
        this.$refs.logList.reload();
      }
      if (this.$refs.reportTable) {
        this.$refs.reportTable.setReport(this.reportData);
      }
      if (this.$refs.axaptbills) {
        this.$refs.axaptbills.getTableData();
      }
      this.$refs.reportTable.$forceUpdate();
    },
    materialLookedUp (materialIds) {
      this.$refs.reportTable.focusInputById(materialIds);
    },
    downloadReport () {
      this.ApiRequest.request(this.requestPath + '/pdf', this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
      })
    },
    openBillAttachFrm () {
      this.$refs.clientBillAttach.show({ client: this.client, clientReport: this.clientReport });
    },
    reloadBills (bills) {
      this.clientReport.bills = bills;
      this.$forceUpdate();
    }
  },
  mounted () {
    this.datePeriodCode = this.$route.params.datePeriodCode;
    this.reportCode = this.$route.params.reportCode
    this.clientApiId = this.$route.params.clientApiId;
    this.mounted = true;
    this.getReportData();
  }
}
